import stories from './stories';
import optIns from './optIns';
import dealerData from './dealerData';
import accountInfo from './accountInfo';

const root = {
	optIns,
	stories,
	dealerData,
	accountInfo
};

export default root;
